import { Tab, TabList, Tabs, VStack } from '@chakra-ui/react';
import { ContractSystemType } from '@client/graphql/__generated__/types';
import { FC } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { useAppContext } from '~/services/main/contexts/AppContext';
import { Container } from '../../components/Layouts/Container';
import {
  FeatureKey,
  useIsFeatureEnabledForPayload,
} from '../../hooks/useIsFeatureEnabledForPayload';

export const OrganizationAdminPage: FC = () => {
  const location = useLocation();
  const { selectedOrganization } = useAppContext();

  const dotloopProfileId =
    selectedOrganization?.contractSystemCredentials?.find(
      (cred) =>
        cred.type === ContractSystemType.DOTLOOP &&
        cred.dotloopProfileId?.trim()
    )?.dotloopProfileId ?? '';

  const isDotloopComplianceGroupFeatureEnabled = useIsFeatureEnabledForPayload({
    featureFlagKey: FeatureKey.DOTLOOP_COMPLIANCE_GROUP,
    organizationId: selectedOrganization?.id,
  });

  const tabs = [
    { path: 'members', label: 'Members', enabled: true },
    { path: 'integration-connections', label: 'Integrations', enabled: true },
    {
      path: 'dotloop-workflows',
      label: 'Dotloop Workflows',
      enabled:
        isDotloopComplianceGroupFeatureEnabled &&
        (!!dotloopProfileId || window.ENVS?.environment === 'development'),
    },
  ].filter((tab) => tab.enabled);

  const activeIndex = tabs.findIndex((tab) =>
    location.pathname.includes(tab.path)
  );

  return (
    <Container maxWidth="container.xl" overflowX="auto">
      <VStack alignItems="stretch" spacing={4}>
        <Tabs index={activeIndex !== -1 ? activeIndex : 0}>
          <TabList>
            {tabs.map((tab) => (
              <Tab key={tab.path} as={NavLink} to={tab.path}>
                {tab.label}
              </Tab>
            ))}
          </TabList>
        </Tabs>

        <Outlet />
      </VStack>
    </Container>
  );
};
